import Vue from 'vue'
import Router from 'vue-router'

// nav导航模板
import index from '@/components/index'
import contactUs from '@/components/contactUs'
import notice from '@/components/notice'
import associationNewsDetail from '@/components/associationNewsDetail'
import newDetail from '@/components/newDetail'
import associationIntroduce from '@/components/associationIntroduce'
// import associationNews from '@/components/associationNews'
// import serviceGuide from '@/components/serviceGuide'
// import continueEducation from '@/components/continueEducation'
// import newsInformation from '@/components/newsInformation'
// import pharmaceuticalCare from '@/components/pharmaceuticalCare'
import newsList from '@/components/newsList'



//个人中心模板
import studentsNote from '@/components/my/studentsNote' //学员须知
import myInfo from '@/components/my/myInfo/index' //个人信息
import pay from '@/components/my/pay/index' //支付
import onlineTeaching from '@/components/my/onlineTeaching' // 网授课
import signStudy from '@/components/my/signStudy/index' // 网授课
import publicSignStudy from '@/components/my/publicSignStudy/index' // 网授课
import myOrder from '@/components/my/order'
import requestInvoice from '@/components/my/requestInvoice'
import requestRefund from '@/components/my/requestRefund'
import examList from '@/components/my/exam/lists'
import exam from '@/components/my/exam/index'

import myCourse from '@/components/my/myCourse/index'
import myCourseCopy from '@/components/my/myCourse/index'



import videoLearning from '@/components/my/videoLearning'
import publicVideoLearning from '@/components/my/publicVideoLearning' // 公需课视频

import faceCollection from '@/components/my/faceCollection/faceCollection'
// import faceCollection from '@/components/my/faceCollection' 
import mockExam from '@/components/my/mockExam'
import agreement from '@/components/my/agreement'
// 药师考核
import assessment from '@/components/my/assessment'
// 公需科目
import publicCourse from '@/components/my/myPublicCourse/index'

//下载页面

import downloadApp from '@/components/downloadApp'



Vue.use(Router)

export default new Router({
  routes: [
    // nav导航路由
    {
      path: '/',
      name: 'index',
      component: index
    },

    {
      path: '/notice',
      name: 'notice',
      component: notice
    },

    {
      path: '/associationNewsDetail',
      name: 'associationNewsDetail',
      component: associationNewsDetail
    },
    {
      path: '/newDetail',
      name: 'newDetail',
      component: newDetail
    },
    {
      path: '/associationIntroduce',
      name: 'associationIntroduce',
      component: associationIntroduce
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: newsList
    },

    //个人中心路由
    {
      path: '/studentsNote',
      name: 'studentsNote',
      component: studentsNote,
      meta: {
        title: '学员须知',
        active: 'studentsNote',
        isLogin: true
      }
    },
    {
      path: '/myInfo',
      name: 'myInfo',
      component: myInfo,
      meta: {
        title: '个人信息',
        active: 'myInfo',
        isLogin: true
      }
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay,
      meta: {
        title: '个人信息',
        active: 'pay',
        isLogin: true
      }
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam,
      meta: {
        title: '课后练习',
        active: 'exam',
        isLogin: true
      }
    },
    {
      path: '/examList',
      name: 'examList',
      component: examList,
      meta: {
        title: '课后练习',
        active: 'exam',
        isLogin: true
      }
    },


    {
      path: '/onlineTeaching',
      name: 'onlineTeaching',
      component: onlineTeaching,
      meta: {
        title: '报名学习',
        active: 'onlineTeaching',
        isLogin: true
      }
    },
    {
      path: '/signStudy',
      name: 'signStudy',
      component: signStudy,
      meta: {
        title: '专业选课',
        active: 'signStudy',
        isLogin: true
      }
    },
    {
      path: '/publicSignStudy',
      name: 'publicSignStudy',
      component: publicSignStudy,
      meta: {
        title: '公需选课',
        active: 'publicSignStudy',
        isLogin: true
      }
    },
    {
      path: '/myOrder',
      name: 'myOrder',
      component: myOrder,
      meta: {
        title: '我的订单',
        active: 'myOrder',
        isLogin: true
      }
    },

    {
      path: '/requestInvoice',
      name: 'requestInvoice',
      component: requestInvoice,
      meta: {
        title: '我的订单',
        active: 'myOrder',
        isLogin: true
      }
    },


    {
      path: '/requestRefund',
      name: 'requestRefund',
      component: requestRefund,
      meta: {
        title: '我的订单',
        active: 'myOrder',
        isLogin: true
      }
    },

    {
      path: '/myCourse',
      name: 'myCourse',
      component: myCourse,
      meta: {
        title: '专业学习',
        active: 'myCourse',
        isLogin: true,
      }
    },
    {
      path: '/publicCourse',
      name: 'publicCourse',
      component: publicCourse,
      meta: {
        title: '公需学习',
        active: 'publicCourse',
        isLogin: true,
      }
    },
    {
      path: '/myCourseCopy',
      name: 'myCourse',
      component: myCourse,
      meta: {
        title: '补学教育',
        active: 'myCourseCopy',
        isLogin: true,
      }
    },



    {
      path: '/videoLearning',
      name: 'videoLearning',
      component: videoLearning,
      meta: {
        title: '课程学习',
        active: 'myCourse',
        isLogin: true
      }
    },
    {
      path: '/publicVideoLearning',
      name: 'publicVideoLearning',
      component: publicVideoLearning,
      meta: {
        title: '公需课程学习',
        active: 'publicCourse',
        isLogin: true
      }
    },

    {
      path: '/faceCollection',
      name: 'faceCollection',
      component: faceCollection
    },

    {
      path: '/mockExam',
      name: 'mockExam',
      component: mockExam,
      meta: {
        title: '我的订单',
        active: 'myOrder',
        isLogin: true
      }
    },

    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
      meta: {
        title: '个人信息及隐私保护政策',
        active: 'agreement',
        isLogin: true
      }
    },
    // 药师考核小程序码
    {
      path: '/assessment',
      name: 'assessment',
      component: assessment,
      meta: {
        title: '药师考核',
        active: 'assessment',
        isLogin: true
      }
    },

    //下载页面路由
    {
      path: '/downloadApp',
      name: 'downloadApp',
      component: downloadApp
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js